import { Grid, IconButton, Tooltip } from '@mui/material'
import { useCallback, useEffect, useState } from 'react'
import { IoReload } from 'react-icons/io5'
import { MdAdd, MdArrowBack, MdDelete } from 'react-icons/md'
import Programa from '../../../components/Programa/Programa'
import { metodoPrograma } from '../../../components/api'
import Edicao from './Edicao'
import { useModal } from '../../../components/Utils/UseModal'
import ModalConfirmacao from '../../utils/modal/ModalConfirmacao'
import { setSuccess } from '../../../components/alerts'
import PrimeTable from '../../../components/PrimeTable'

const Equipamento = () => {
  const openModal = useModal(ModalConfirmacao)

  const [tela, setTela] = useState('lista')
  const [ferramentas, setFerramentas] = useState()
  const [dados, setDados] = useState(null)
  const [atualiza, setAtualiza] = useState(true)

  const voltar = useCallback(() => {
    setTela('lista')
    setDados(undefined)
    setAtualiza((v) => !v)
  }, [])

  const exclui = (equipamento) => async (e) => {
    e.stopPropagation()
    if (
      await openModal({
        titulo: `Mas você tem CERTEZA que deseja ${equipamento[8] ? 'ativar' : 'excluir'} "${equipamento[1]}" ?`,
      })
    ) {
      setSuccess(
        `Equipamento: ${equipamento[1]} ${equipamento[8] ? 'ativado' : 'excluido'} com sucesso!`,
      )
      await metodoPrograma('exclui', { idEquipamento: equipamento[0] })
      setAtualiza((v) => !v)
    }
  }

  const handleClick = (linha) => {
    setDados(linha)
    setTela('opcoes')
  }

  useEffect(() => {
    switch (tela) {
      case 'lista':
        setFerramentas(
          <Tooltip title="Adicionar">
            <IconButton onClick={() => setTela('opcoes')}>
              <MdAdd />
            </IconButton>
          </Tooltip>,
        )
        break
      case 'opcoes':
        setFerramentas(
          <Tooltip title="Voltar">
            <IconButton onClick={voltar}>
              <MdArrowBack />
            </IconButton>
          </Tooltip>,
        )
        break
      default:
        break
    }
  }, [tela, voltar])

  return (
    <Programa codigo="CtrlEquipamento" ferramentas={ferramentas}>
      {tela === 'lista' ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <PrimeTable
              action="lista"
              codigo="CtrlEquipamento"
              refresh={atualiza}
              head={[
                'Equipamento',
                'Patrimonio',
                'Dt. Compra',
                'Nr. Serie',
                'Modelo',
                'Fabricante',
                'Observação',
                'Dt. Garantia',
                '',
              ]}
              line={(item) => [
                item[1],
                item[2],
                item[3],
                item[4],
                item[6],
                item[5],
                item[7],
                item[9],
                '',
              ]}
              collumnsDate={[2, 7]}
              columnOptions={[
                {
                  alias: 8,
                  customJsx: ({ linhaOriginal }) => (
                    <IconButton size="small" onClick={exclui(linhaOriginal)}>
                      {linhaOriginal[8] ? <IoReload /> : <MdDelete />}
                    </IconButton>
                  ),
                },
              ]}
              onRowSelect={handleClick}
            />
          </Grid>
        </Grid>
      ) : (
        <Edicao {...{ dados, voltar, setTela }} />
      )}
    </Programa>
  )
}

export default Equipamento
